module.exports = "https://img1.huilianyi.com/e/create-er@3x.e19f155309.appcore.png";